<template>
  <section class="sharee-popup-wrapper">
    <van-popup
      v-model="showPopup"
      class="fission-sharee-popup"
      get-container=".sharee-popup-wrapper"
      @opened="opened"
      @closed="closed"
      :style="{ width: '100%' }"
    >
      <div class="popup-logo">
        <img
          class="icon"
          v-lazy="
            require(`@/assets/images/activities/fission/pubgm/toplupe-pubgm.png`)
          "
          alt="logo"
        />
      </div>
      <div class="popup-body">
        <img
          class="personage"
          v-lazy="
            require(`@/assets/images/activities/fission/pubgm/pubgm-personage.png`)
          "
          alt="logo"
        />
        <div :class="['coupon-bar']">
          <p>{{ getTitle.title }}</p>
        </div>
        <div class="sharee-infos">
          <div class="desc">
            <p>
              {{ sharerUserInfos && sharerUserInfos.userName }}
              {{ getTitle.subTitle }}
            </p>
          </div>
          <div class="triangle"></div>
          <img
            class="avatar"
            v-lazy="sharerUserInfos && sharerUserInfos.avatarUrl"
            alt="logo"
          />
        </div>
      </div>
      <button class="loginBtn" @click="toLogin">
        {{ $t('fission.go-to-register') }}
      </button>
    </van-popup>
  </section>
</template>
<script>
  // 被分享者弹框
  import { mapState } from 'vuex'
  import { getUserInfo } from '@/api/fission'

  export default {
    data() {
      return {
        showPopup: true,
        sharerUserInfos: {},
      }
    },
    computed: {
      ...mapState(['fissionInfos']),
      getTitle() {
        const {
          extraInfo: { noLoginToShareTitle, noLoginToShareDesc },
        } = this.fissionInfos

        return {
          title: noLoginToShareTitle,
          subTitle: noLoginToShareDesc,
        }
      },
    },
    mounted() {
      const { attachedKicoinId = '' } = this.$route.query
      getUserInfo(attachedKicoinId).then((res) => {
        this.sharerUserInfos = res
      })
    },
    methods: {
      opened() {
        this.$emit('opened')
      },
      closed() {
        this.$emit('closed')
      },
      toLogin() {
        this.$emit('toLogin')
      },
    },
  }
</script>
<style lang="scss" scoped>
  .sharee-popup-wrapper {
    padding: 0 108px;
    box-sizing: border-box;
    .fission-sharee-popup {
      background-color: transparent;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-image: url('~@/assets/images/activities/fission/pubgm/popup-bg-bottom.png');
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      padding-top: 30px;
      box-sizing: border-box;
      .popup-logo {
        width: 100%;
        padding-right: 108px;
        box-sizing: border-box;
        display: flex;
        justify-content: flex-end;
        margin-bottom: 30px;
        .icon {
          height: 58px;
        }
      }
      .popup-body {
        width: 864px;
        height: 596px;
        border-radius: 36px;
        background-image: url('~@/assets/images/activities/fission/pubgm/pubgm-bg.png');
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;
        padding: 108px 30px 18px 30px;
        box-sizing: border-box;
        .personage {
          width: 416px;
          object-fit: cover;
          transform: translateY(-126px);
          position: absolute;
          left: 0;
          top: 0;
        }
        .coupon-bar {
          width: 429px;
          height: 196px;
          background-image: url('~@/assets/images/activities/fission/pubgm/coupon-sharee-bg.png');
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
          font-weight: 700;
          font-size: 64px;
          line-height: 1.5;
          color: #96460c;
          margin-right: 16px;
          padding: 20px;
          box-sizing: border-box;
          display: flex;
          justify-content: center;
          align-items: center;
          p {
            width: 100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            text-align: center;
          }
        }
        .sharee-infos {
          margin-top: 64px;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 180px;
          max-height: 180px;
          .desc {
            max-height: 180px;
            background: #000;
            font-weight: 600;
            font-size: 32px;
            line-height: 1.44;
            display: flex;
            align-items: center;
            border-radius: 6px;
            padding: 30px;
            box-sizing: border-box;
            border-right: 3px solid #ffc52f;
            position: relative;
            flex: 1;
            p {
              color: #ffbe3f;
              @include canWrap($lineCount: 3);
            }
          }
          .triangle {
            width: 24px;
            height: 24px;
            background: #000;
            border-top: 3px solid #ffc52f;
            border-right: 3px solid #ffc52f;
            transform: translateX(-14px) rotate(45deg);
          }
          .avatar {
            width: 102px;
            height: 102px;
            border: 3px solid #ffc52f;
            border-radius: 50%;
            flex-shrink: 0;
            margin-left: 12px;
          }
        }
      }
      .loginBtn {
        width: 624px;
        height: 140px;
        margin-top: 70px;
        background-image: url('~@/assets/images/activities/fission/pubgm/login-btn-new.png');
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;

        font-weight: 600;
        font-size: 60px;
        line-height: 1;
        color: #833e0d;
        padding-bottom: 12px;
      }
    }
  }
</style>
